<div class="wrapper-qrcode">
    <qr-code
        class="qr-code"
        [value]="qrCode"
        [size]="240"
    ></qr-code>
    <p class="hash">Para subir seus exames faça a leitura do QR Code</p>
</div>
